import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function CreatePlatformPolicy(platformPolicy) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + platformPolicy.tournament_id + '/platform_policies', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({platform_policy: platformPolicy})
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }   

  return { status: response.status, ...(await response.json()) };
}

export async function UpdatePlatformPolicy(id, platformPolicy) {
  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + platformPolicy.tournament_id + '/platform_policies/' + id, {
    method: 'PUT',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    },
    body: JSON.stringify({platform_policy: platformPolicy})
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }   

  return { status: response.status, ...(await response.json()) };
}

export async function GetPlatformPolicy(tournamentId, id) {
  const token = getAuthToken()

  if (token === null) {
    return null
  }

  const response = await fetch(config.apiBaseUrl + '/rest/admin/tournaments/' + tournamentId + '/platform_policies/' + id, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, ...(await response.json()) };
}

export async function ListPlatformPolicies(tournamentId, page) {
  const token = getAuthToken()

  if (token === null) {
    return { data: [], pagination: {} }
  }

  const url = config.apiBaseUrl + `/rest/admin/tournaments/` + tournamentId + `/platform_policies` + (page ? `?page=${page}` : '')
  const response = await fetch(url, {
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  });

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }   

  return { status: response.status, ...(await response.json()) };
}

export async function DeletePlatformPolicy(tournamentId, id) {
  const response = await fetch(config.apiBaseUrl + `/rest/admin/tournaments/${tournamentId}/platform_policies/${id}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }   

  return response.status === 204
}

export function PlatformPolicyOptionsList() {
  return [
    {key: 'android', value: 'android', name: 'Android'},
    {key: 'ios', value: 'ios', name: 'iOS'},
    {key: 'web', value: 'web', name: 'Web'}
  ]
}

export function PlatformPolicyFindOption(value) {
  const list = PlatformPolicyOptionsList()

  const filtered_list = list.filter((item) => item.value === value)

  if (filtered_list.length > 0) {
    return filtered_list[0]
  }

  return null
}

export function PlatformPolicyOptionNameByValue(value) {
  const platformPolicyOption = PlatformPolicyFindOption(value)

  return platformPolicyOption ? platformPolicyOption.name : ""
}

export function PlatformPolicyRestrictionsList() {
  return [
    {key: 'none', value: 'none', name: 'Nenhuma restrição'},
    {key: 'read_only', value: 'read_only', name: 'Somente leitura'},
    {key: 'full', value: 'full', name: 'Restrição total'}
  ]
}

export function PlatformPolicyFindRestriction(value) {
  const list = PlatformPolicyRestrictionsList()

  const filtered_list = list.filter((item) => item.value === value)

  if (filtered_list.length > 0) {
    return filtered_list[0]
  }

  return null
}

export function PlatformPolicyRestrictionNameByValue(value) {
  const platformPolicyRestriction = PlatformPolicyFindRestriction(value)

  return platformPolicyRestriction ? platformPolicyRestriction.name : ""
}